'use strict';
module.exports = function initialRenameMediator(config, collaborationModel, pageController) {
	if (!config || !collaborationModel || !pageController) {
		throw new Error('invalid-args');
	}
	let rootId, potentialRename = false;
	const titleFromEvent = (localEvent) => {
			if (!localEvent || !localEvent.args || !Array.isArray(localEvent.args) || !localEvent.args.length || !['batch', 'updateTitle'].includes(localEvent.cmd)) {
				return false;
			}
			if (localEvent.cmd === 'batch') {
				const updateTitleBatchItem = localEvent.args.find(batchItem => {
					return Array.isArray(batchItem) && batchItem[0] === 'updateTitle' && batchItem[1] === rootId;
				});
				return updateTitleBatchItem && Array.isArray(updateTitleBatchItem) && updateTitleBatchItem[2];
			} else {
				return localEvent.args[0] === rootId && localEvent.args[1];
			}
		},
		processLocalEvent = function (localEvent) {
			if (!potentialRename) {
				return;
			}
			const rootNodeTitle = titleFromEvent(localEvent);

			if (rootNodeTitle && rootNodeTitle !== config.defaultFileTitle) {
				pageController.renameFromDefault(rootNodeTitle);
			}
		};
	pageController.addEventListener('fileLoaded', function (fileId, title) {
		potentialRename = (title === config.defaultFileTitle);
	});
	pageController.addEventListener('renamed', title => {
		potentialRename = (title === config.defaultFileTitle);
	});
	collaborationModel.addEventListener('newSession', function (contentAggregate) {
		rootId = contentAggregate.getDefaultRootId();
	});
	collaborationModel.addEventListener('localContentEvent', processLocalEvent);
};
